import { BrandController } from "controllers";
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";

const country = localStorage.getItem('country');

async function dataStream(callback) {
  const brands = await BrandController.getBrands(country);
  callback(sortArrayPipe.transform(brands, 'value'));
}

const BrandSelect = withBaseSelect([], dataStream);
export default BrandSelect;
